import { render, staticRenderFns } from "./TerminalsDashboard.vue?vue&type=template&id=9087d7dc"
import script from "./TerminalsDashboard.vue?vue&type=script&lang=js"
export * from "./TerminalsDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports